const RESOURCE_CLEAR_ERROR = 'bfb/IPRESOURCE/RESOURCE_CLEAR_ERROR';
const RESOURCES_LIST = 'bfb/IPRESOURCE/RESOURCES_LIST';
const RESOURCES_LIST_SUCCEEDED = 'bfb/IPRESOURCE/RESOURCES_LIST_SUCCEEDED';
const RESOURCES_LIST_FAILED = 'bfb/IPRESOURCE/RESOURCES_LIST_FAILED';
const RESOURCE_CREATE = 'bfb/IPRESOURCE/RESOURCE_CREATE';
const RESOURCE_CREATE_SUCCEEDED = 'bfb/IPRESOURCE/RESOURCE_CREATE_SUCCEEDED';
const RESOURCE_CREATE_FAILED = 'bfb/IPRESOURCE/RESOURCE_CREATE_FAILED';
const RESOURCE_DELETE = 'bfb/IPRESOURCE/RESOURCE_DELETE';
const RESOURCE_DELETE_SUCCEEDED = 'bfb/IPRESOURCE/RESOURCE_DELETE_SUCCEEDED';
const RESOURCE_DELETE_FAILED = 'bfb/IPRESOURCE/RESOURCE_DELETE_FAILED';
const RESOURCE_FETCH = 'bfb/IPRESOURCE/RESOURCE_FETCH';
const RESOURCE_FETCH_SUCCEEDED = 'bfb/IPRESOURCE/RESOURCE_FETCH_SUCCEEDED';
const RESOURCE_FETCH_FAILED = 'bfb/IPRESOURCE/RESOURCE_FETCH_FAILED';
const RESOURCE_UPDATE = 'bfb/IPRESOURCE/RESOURCE_UPDATE';
const RESOURCE_UPDATE_SUCCEEDED = 'bfb/IPRESOURCE/RESOURCE_UPDATE_SUCCEEDED';
const RESOURCE_UPDATE_FAILED = 'bfb/IPRESOURCE/RESOURCE_UPDATE_FAILED';

export default {
  RESOURCES_LIST,
  RESOURCES_LIST_SUCCEEDED,
  RESOURCES_LIST_FAILED,
  RESOURCE_CLEAR_ERROR,
  RESOURCE_CREATE,
  RESOURCE_CREATE_SUCCEEDED,
  RESOURCE_CREATE_FAILED,
  RESOURCE_DELETE,
  RESOURCE_DELETE_SUCCEEDED,
  RESOURCE_DELETE_FAILED,
  RESOURCE_FETCH,
  RESOURCE_FETCH_SUCCEEDED,
  RESOURCE_FETCH_FAILED,
  RESOURCE_UPDATE,
  RESOURCE_UPDATE_SUCCEEDED,
  RESOURCE_UPDATE_FAILED,
};
